module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Coffee#1-b1cb3b5cf9a881f449b1ea80144ae799.svg";